import { Component } from '@angular/core';
import { ActivationForm } from '@net3-multiplatform-client/libs';

@Component({
  selector: 'app-activation',
  imports: [
    ActivationForm
  ],
  templateUrl: './activation-form.component.html'
})
export class Activation {}
